import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {ProgressBarLoaderComponent} from '../common/progress-bar-loader/progress-bar-loader.component';
import { FormsModule } from '@angular/forms';
import { HttpService } from '../services/http.service';
import { MatDialog } from '@angular/material/dialog';
import { LinkInputPopupComponent } from '../common/popups/link-input-popup/link-input-popup.component';
import { FileUploadPopupComponent } from '../common/popups/file-upload-popup/file-upload-popup.component';
import { LinksDialogComponent } from '../links-dialog/links-dialog.component';
import { ValidityScoreComponent } from "../common/validity-score/validity-score.component";
import { DataService } from '../services/data.service';
import { EditLinksDialogComponent } from './edit-links-dialog.component';
import { TruncateTextWidthDirective } from '../common/directives/truncate.directive';
import { AppConstants } from '../../constants/app.constants';
import { Document, Packer, Paragraph, Table, TableCell, TableRow, TextRun, ExternalHyperlink, WidthType, HeadingLevel } from 'docx';
import { saveAs } from 'file-saver';
import {jsPDF} from 'jspdf';
import html2canvas from 'html2canvas';
import { EditClaimchartPopupComponent } from '../common/popups/edit-claimchart-popup/edit-claimchart-popup.component';
import { ClickOutsideDirective } from '../common/directives/click-outside.directive';


@Component({
  selector: 'app-infringement-analysis',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, FormsModule, HttpClientModule, ProgressBarLoaderComponent, ValidityScoreComponent, TruncateTextWidthDirective, ClickOutsideDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './infringement-analysis.component.html',
  styleUrls: ['./infringement-analysis.component.css']
})
export class InfringementAnalysisComponent implements OnInit {
  isLoading: boolean = false;
  @Input() patentData: any = [
]
  currentStage: number = 2;
  loadingText: string = 'Loading, please wait';
  titleText: string = 'Infringement Assessment';
  patentDetails: any[] = [];
  mock: boolean = false; // Set this to true for mock responses
  isEditingCompanies: boolean = false;
  isEditingProducts: boolean = false;
  industryData=[];
  @Input() updateData:any;
  @Input() updateRoute:any;
  errorMessage:any=null;

  apiResponse:any={};

  optimizedFlow:boolean=false;

  constructor(private http: HttpService, public dialog: MatDialog, public dataService:DataService) {

    this.patentData= this.dataService.industryData;
    this.updateData=this.dataService.updateDataSameStructure.bind(this.dataService);
    this.updateRoute=this.dataService.updateRouteObservable.bind(this.dataService);
    this.optimizedFlow=this.dataService.optimizedFlow;
    this.industryData=this.dataService.industryData;
  }
  
  ngOnInit(): void {
    this.patentDetails=this.patentData;
    console.log('patentDetails', this.patentDetails)
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
    
        this.companySelectionList.push(`${company.name}-${patentInfo.patentNumber}`);
        this.productSelectionList.push(...company.products.map((product:any)=>`${product.name}-${company.name}-${patentInfo.patentNumber}`));
      });
    });
    if(this.dataService.isStorageFull&&this.dataService.isReloadScenario)
      {
        this.isLoading = true;
        this.loadingText = 'Synchronizing Data, please wait';
        this.dataService.getWorkflowDataAndUpdateValues().then(() => {
          this.isLoading = false;
          this.handleDataServiceRetention();
        }).catch((error) => {
          console.error('Error during data synchronization:', error);
          this.isLoading = false;
          this.isError = true;
        }
        );
      }
      else 
      {
        this.handleDataServiceRetention();
      }
  }

  handleDataServiceRetention(){
    let candidateData=this.dataService.infringementData;
    console.log('candidateData', candidateData)
    if(candidateData&&candidateData.patentDetails&&candidateData.patentInfringementScoreData&&candidateData.claimChartData){
      // {patentDetails: this.patentDetails,patentInfringementScoreData:this.patentInfringementScoreData, claimChartData:this.claimChartData } reverse parse this json
      this.patentDetails=candidateData.patentDetails;
      this.patentInfringementScoreData=candidateData.patentInfringementScoreData;
      this.claimChartData=candidateData.claimChartData;
      if(!this.optimizedFlow){
        this.onFinalNext();
      }
      if(window.sessionStorage.getItem('notSurpass'))
      {
        this.currentStage=4;
      }
      else
        this.currentStage=5;
    }
    else if (candidateData&&candidateData.patentDetails){
      
      this.patentDetails=candidateData.patentDetails;
    this.patentDetails=this.patentDetails.filter((patent:any)=>patent.companies.length>0);

      if(!this.optimizedFlow){
        this.proceedToClaimChartGeneration();
    }
    else{
      this.currentStage=3;
      this.isLoading = false;
    }
    }
    else{ 
      if(!this.optimizedFlow){
        
        this.proceedToTargetLinks();
      }
    }
  }

  companySelectionList:any=[];
  productSelectionList:any=[];
  claimChartData:any= []
  patentInfringementScoreData:any={}

  handleCompanyCheckboxChange(companyObject:any, patentNumber:any, eventTarget:any){
    const companyKey = `${companyObject.name}-${patentNumber}`;
    if(eventTarget.checked){
      this.companySelectionList.push(companyKey);
      this.productSelectionList.push(...companyObject.products.map((product:any)=>`${product.name}-${companyKey}`));
      this.productSelectionList=[...new Set(this.productSelectionList)];
    }
    else{
      this.companySelectionList=this.companySelectionList.filter((company:any)=>company!==companyKey);
      this.productSelectionList=this.productSelectionList.filter((product:any)=>!companyObject.products.map((product:any)=>`${product.name}-${companyKey}`).includes(product));
    }  
  }

  getCompanyCheckboxChecked(companyObject:any, patentNumber:any){
    const companyKey = `${companyObject.name}-${patentNumber}`;
    return this.companySelectionList.includes(companyKey);
  }

  handleProductCheckboxChange(productObject:any, productCompanyObject:any, patentNumber:any, eventTarget:any){
    let companyKey = `${productCompanyObject.name}-${patentNumber}`;
    let productKey = `${productObject.name}-${companyKey}`;
    if(eventTarget.checked){
      this.productSelectionList.push(productKey);
      if(!this.companySelectionList.includes(companyKey)){
        this.companySelectionList.push(companyKey);
      }
    }
    else{
      this.productSelectionList = this.productSelectionList.filter((product:any) => product !== productKey);
      // check if no product from the company is selected
      // if(!this.productSelectionList.some((product:any) => product.includes(companyKey))){
      if(!this.companySelectionList.includes(companyKey)){
        this.companySelectionList = this.companySelectionList.filter((company:any) => company !== companyKey);
      }
    }
  }

  getProductCheckboxChecked(productObject:any, productCompanyObject:any, patentNumber:any){
    let companyKey = `${productCompanyObject.name}-${patentNumber}`;
    let productKey = `${productObject.name}-${companyKey}`;
    // console.log(productKey)
    // console.log(this.productSelectionList.includes(productKey),  this.companySelectionList.includes(companyKey))
    return this.productSelectionList.includes(productKey) && this.companySelectionList.includes(companyKey);
  }
    

  toggleAllCompanies(event:any){
    console.log('checkboxevent',event.target.checked, event)
    if(event.target.checked!=true){
      this.companySelectionList=[];
      this.productSelectionList=[];
    }
    else{
      this.companySelectionList=[];
      this.productSelectionList=[];
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          this.companySelectionList.push(`${company.name}-${patentInfo.patentNumber}`);
          this.productSelectionList.push(...company.products.map((product:any)=>`${product.name}-${company.name}-${patentInfo.patentNumber}`));
        });
      });
    }
    return event.target.checked;
  }

  allCompaniesChecked(){
    console.log('checkbox', this.companySelectionList.length>0 && this.companySelectionList.length==this.patentDetails.reduce((acc, patentInfo)=>acc+patentInfo.companies.length, 0))
    return this.companySelectionList.length>0 && this.companySelectionList.length==this.patentDetails.reduce((acc, patentInfo)=>acc+patentInfo.companies.length, 0)&&this.productSelectionList.length>0 && this.productSelectionList.length==this.patentDetails.reduce((acc, patentInfo)=>acc+patentInfo.companies.reduce((acc:any, company:any)=>acc+company.products.length, 0), 0);
  }

  proceedToTargetLinks(){
    this.currentStage=1;
    // filter the patent details based on the selected companies and products
    this.patentDetails=this.patentData.map((patent:any)=>{
      return {
        ...patent,
        companies: patent.companies.filter((company:any)=>this.companySelectionList.includes(`${company.name}-${patent.patentNumber}`)).map((company:any)=>{
          return {
            ...company,
            products: company.products.filter((product:any)=>this.productSelectionList.includes(`${product.name}-${company.name}-${patent.patentNumber}`))
          }
        })
      }
    });
    // filter to only those patents that have at least one company or product selected
    this.patentDetails=this.patentDetails.filter((patent:any)=>patent.companies.length>0);
    this.claimChartData=[];
    this.patentInfringementScoreData={};
    // this.getTargetLinks();
    this.getTargetLinksBatch();
  }

  proceedToClaimChartGeneration(){
    this.currentStage=3;
    // this.currentStage=4
    this.generateClaimChart();
    
  }

  proceedToSummary(){
    this.titleText="Summary";
    window.sessionStorage.removeItem('notSurpass');
    this.currentStage=5;
  }

  onFinalNext(){
    // this.saveClaimCharts().then(()=>{

    this.updateData({patentDetails: this.patentDetails,patentInfringementScoreData:this.patentInfringementScoreData, claimChartData:this.claimChartData }, "infringement", false)
    this.updateRoute("industry-analysis")
    // }).catch(error => {
    //   console.error('Error saving claim charts:', error);
    // }
    // )

  }

  saveClaimCharts(){
   return this.http.post('/infringement-assessment/save-claim-charts', {data: this.apiResponse}).then(response => {
      console.log(response)
    })
  }



  getTargetLinks(){
    /*
     Endpoint: /infringement-assesment/techinical-documentation
     Request: {"data": list of dictionaries ([{}, {}, {},………..])}
where each dictionary is {"targeted_company": str, "targeted_product": str}
Response:{
    "technical_documentation_links": [
        {
            "targeted_company": "Samsung Healthcare",
            "targeted_product": "Samsung Healthcare Computed Tomography Devices with Photon Counting Detector (PCD) Technology",
            "technical_documentation_links": [
                "https://www.surgicalroboticstechnology.com/news/neurologica-wins-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite/",
                "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite",
                "https://www.neurologica.com/publications/press-releases/samsung-ushers-in-a-new-era-of-diagnostic-solutions-at-rsna-2023",
                "https://www.samsunghealthcare.com/en/about_us/news_center/310",
                "https://www.neurologica.com/publications/press-releases/neurologicas-omnitom-elite-ct-scanner-now-available-0",
                "https://news.samsung.com/global/samsungs-push-to-leverage-artificial-intelligence-on-display-at-rsna-2021",
                "https://news.samsung.com/global/neurologica-corp-receives-fda-510k-clearance-for-enhanced-omnitom-elite-with-ultra-high-resolution-pcd-technology",
                "https://samsunghealthcare.com/en/about_us/news_center/185",
                "https://www.massdevice.com/fda-clears-neurologicas-omnitom-elite-with-photon-counting-detector-technology/",
                "https://samsunghealthcare.com/en/rsna2022"
            ]
        },
  }/**
   * 
   */
  if(this.mock){
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        company.products.forEach((product:any) => {
          product.technicalDocumentationLinks=[
            "https://www.surgicalroboticstechnology.com/news/neurologica-wins-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite/",
            "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite",
            "https://www.neurologica.com/publications/press-releases/samsung-ushers-in-a-new-era-of-diagnostic-solutions-at-rsna-2023",
            "https://www.samsunghealthcare.com/en/about_us/news_center/310",
            "https://www.neurologica.com/publications/press-releases/neurologicas-omnitom-elite-ct-scanner-now-available-0",
            "https://news.samsung.com/global/samsungs-push-to-leverage-artificial-intelligence-on-display-at-rsna-2021",
            "https://news.samsung.com/global/neurologica-corp-receives-fda-510k-clearance-for-enhanced-omnitom-elite-with-ultra-high-resolution-pcd-technology",
            "https://samsunghealthcare.com/en/about_us/news_center/185",
            "https://www.massdevice.com/fda-clears-neurologicas-omnitom-elite-with-photon-counting-detector-technology/",
            "https://samsunghealthcare.com/en/rsna2022"
          ]
        });
      });
    });
  }
  else {
    let request_body:any=[]
    this.loadingText = 'Fetching technical documentation links, please wait';
    this.isLoading = true;
    console.log(this.patentDetails)
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        company.products.forEach((product:any) => {
          request_body.push({
            targeted_company: company.name,
            targeted_product: product.name
          });
        });
      });
    });
    this.http.post('/infringement-assessment/technical-documentations', {data: request_body}).then(response => {
      let index=0;
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          company.products.forEach((product:any) => {
            product.technicalDocumentationLinks=response.technical_documentation_links[index++].technical_documentation_links;
          });
        });
      });
      console.log('Technical documentation links:', this.patentDetails);
      this.updateData({patentDetails: this.patentDetails}, "infringement", false)
      if(!this.optimizedFlow){
          this.proceedToClaimChartGeneration();
      }
      else{
        this.currentStage=3;
        this.isLoading = false;
      }
    }).catch(error => {
      this.isError=true;
      this.updateData({patentDetails: this.patentDetails}, "infringement", false)
      this.dataService.handleWorkflowError();
      
      console.error('Error fetching technical documentation links:', error);
    });

  }
}

getTargetLinksBatch(){
  const makeApiCall = (targeted_company: string, targeted_product: string) => {
    return this.http.post('/infringement-assessment/technical-documentations', {
      data: [{ targeted_company, targeted_product }]
    });
  };
  
  const executeSequentially = async () => {
    this.loadingText = 'Fetching technical documentation links, please wait';
    this.isLoading = true;
    let errorMessage=null;
    let isError=false;
    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    const batchSize = 5;
  
    const requestItems: any[] = [];
  
    // Map to track which product each request belongs to
    const productMap: any[] = [];
  
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company: any) => {
        company.products.forEach((product: any) => {
          requestItems.push({ targeted_company: company.name, targeted_product: product.name });
          productMap.push(product); // keep same order
        });
      });
    });
  
    const total = requestItems.length;
    const batches = Math.ceil(total / batchSize);
  
    let productIndex = 0;
  
    for (let i = 0; i < batches; i++) {
      const batchStart = i * batchSize;
      const batchEnd = Math.min(batchStart + batchSize, total);
      const batch = requestItems.slice(batchStart, batchEnd);
  
      const promises = batch.map(item =>
        makeApiCall(item.targeted_company, item.targeted_product)
          .then((response: any) => {
            let responseData = response?.technical_documentation_links?.[0];
            console.log(responseData, item, productMap)
            const links = responseData?.technical_documentation_links || [];
            const product = productMap.find(p=> p.name === item.targeted_product );
            product.technicalDocumentationLinks = links;

            productMap.splice(productMap.indexOf(product), 1);
          })
          .catch(error => {
            console.error('Error fetching technical documentation for', item, error);
            this.isError = true;
            errorMessage=error.error.message;
            this.errorMessage=errorMessage;
            isError=true;
            this.dataService.handleWorkflowError();
            productIndex++; // still move index forward even if error
          })
      );
  
      await Promise.all(promises);
      await delay(3000); // delay between batches
    }

    if(isError){
      this.isError=true;
      this.errorMessage=errorMessage;
      this.updateData({patentDetails: this.patentDetails}, "infringement", false)
      this.dataService.handleWorkflowError();
      console.error('Error fetching technical documentation links');
      return;
    }
  
    // Final processing
    this.updateData({ patentDetails: this.patentDetails }, "infringement", false);
  
    if (!this.optimizedFlow) {
      this.proceedToClaimChartGeneration();
    } else {
      this.currentStage = 3;
      this.isLoading = false;
    }
  
    console.log('Technical documentation links:', this.patentDetails);
  };
  
  executeSequentially();
  
  
}

async callCalculateTimeApi(apiDetails: any): Promise<any> {
  const calculateTimeApiUrl = '/api-metrics/calculate-time';
  try {
    const response = await this.http.post(calculateTimeApiUrl, apiDetails);
    return response
  } catch (error) {
    console.error('Error calling calculate-time API:', error);
    return null;
  }
}



isError:boolean=false;

tempScoreData:any=[]

deepCombineObjects(obj1:any, obj2:any){
  let combinedObj:any={};
  for (const key in obj1) {
    if (obj1.hasOwnProperty(key)) {
      if(obj2.hasOwnProperty(key)){
        if(Array.isArray(obj1[key])){
          combinedObj[key]=[...obj1[key], ...obj2[key]];
        }
        else if(typeof obj1[key] === 'object'){
          combinedObj[key]=this.deepCombineObjects(obj1[key], obj2[key]);
        }
        else{
          combinedObj[key]=obj1[key];
        }
      }
      else{
        combinedObj[key]=obj1[key];
      }
    }
  }
  for (const key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if(!obj1.hasOwnProperty(key)){
        combinedObj[key]=obj2[key];
      }
    }
  }
  return combinedObj;
}
sampleresponse=(patentNumber:any)=>{({

  "claim_charts_data": {
        "claim_charts": [
            {
                "patent_number": patentNumber,
                "targeted_product": "Samsung Healthcare Computed Tomography Devices with Photon Counting Detector (PCD) Technology",
                "claim": "A counting detector, comprising: sensors to convert radiation quanta into electrical pulses; an evaluation unit, including a number of energy thresholds, to generate, for each of the sensors, a count value for each of the energy thresholds from the electrical pulses, each of the count values representing a number of radiation quanta with an energy above a respective one of the energy thresholds, wherein one of the energy thresholds is arranged directly above a characteristic energy of radiation quanta causing double counting in order to correct double counting; and a correction unit to calculate a corrected count value from the count values of the energy thresholds, the corrected count value including reduced double counting for at least one of the energy thresholds.",
                "data": [
                    {
                        "claim_element": "- A counting detector  ",
                        "analyst_comment": "The claim element 'A counting detector' is explicitly supported by multiple references to the Photon Counting Detector (PCD) technology utilized in the OmniTom Elite CT scanner. These references describe the functionality and capabilities of the PCD, emphasizing its role in capturing CT data and generating spectral images, which aligns directly with the concept of a counting detector.",
                        "references": [
                            {
                                "reference": "Counting DetectorPhoton Counting Detector (PCD)Samsung NeuroLogica\n\n\nProducts > More ProductsPress Resources > Press Release \n\n\nRelated Articles\n\n\nSamsung’s Push To Leverage Artificial Intelligence on Display at RSNA 2021",
                                "source": "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite"
                            },
                            {
                                "reference": "NeuroLogica Corp, a subsidiary of Samsung Electronics Co. Ltd., announced today its state-of-the-art OmniTom Elite has received 510(k) clearance for the addition of Photon Counting Detector (PCD) technology.",
                                "source": "https://www.neurologica.com/publications/press-releases/neurologicas-omnitom-elite-ct-scanner-now-available-0"
                            },
                            {
                                "reference": "NeuroLogica delivers the first FDA 510(k) cleared, single-source photon counting computed tomography (CT) scanner with single detector.\n\nOmniTom Elite with PCD can generate spectral CT imagesat multiple energy levels.\n\nPhoton counting is a next-generation CT technology that sorts the different energies of X-rays after they have passed through the scan field.\n\nA single X-ray source paired with PCD generates multiple sets of CT data acquired at the same time with configurable energy thresholds without any cross talk between images.\n\nPCD provides the ability to capture CT data in multiple energy bands leading to potentially more accurate visualization and segmentation of bone, blood clots, plaque, hemorrhage, and intracranial tumors.\n\nThere is also potential with PCD to lower the dose requirements, and fundamentally change the use of injected contrast.",
                                "source": "https://www.neurologica.com/publications/press-releases/neurologicas-omnitom-elite-ct-scanner-now-available-0"
                            },
                            {
                                "reference": "The clinical launch of the OmniTom Elite with PCD, the first US FDA 510(k) cleared single-source photon counting computed tomography scanner with a single detector on a mobile system, will be featured at this year’s meeting.\n\nPhoton counting is a next-generation CT technology that sorts the different energies of X-rays after they have passed through the scan field, capturing the X-ray photons directly at the detector and converting the energy to electrical signals.",
                                "source": "https://www.neurologica.com/publications/press-releases/samsung-ushers-in-a-new-era-of-diagnostic-solutions-at-rsna-2023"
                            },
                            {
                                "reference": "The world of medical imaging is no longer just black & white.\n\nNeuroLogica Corp, a subsidiary of Samsung Electronics, announced today its state-of-the-art OmniTom Elite has received 510(k) clearance for the addition of Photon Counting Detector (PCD) technology.\n\nNeuroLogica delivers the first FDA 510(k) cleared, single-source photon counting computed tomography (CT) scanner with single detector.\n\nOmniTom Elite with PCD can generate spectral CT images at multiple energy levels.\n\nPhoton counting is a next-generation CT technology that sorts the different energies of X-rays after they have passed through the scan field.\n\nA single X-ray source paired with PCD generates multiple sets of CT data acquired at the same time with configurable energy thresholds without any cross talk between images.\n\nPCD provides the ability to capture CT data in multiple energy bands leading to potentially more accurate visualization and segmentation of bone, blood clots, plaque, hemorrhage and intracranial tumors.\n\nThere is also potential with PCD to lower the dose requirements, and fundamentally change the use of injected contrast.",
                                "source": "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite"
                            },
                            {
                                "reference": "NeuroLogica Corp, a subsidiary of Samsung Electronics, announced its latest configuration of the mobile computed tomography (CT) OmniTom® Elite with Photon Counting Detector (PCD) technology has received U.S. Food and Drug Administration (FDA) 510(k) clearance.\n\nThis advancement builds upon the existing PCD capabilities with groundbreaking enhancements, further solidifying OmniTom® Elite’s position at the forefront of mobile CT imaging technology.\n\nThe newly cleared features optimized for PCD include several significant innovations:\n \n\nUltra-High-Resolution Mode: This development promises unprecedented clarity and detail in CT imaging.\n\nThe addition of an ultra-high-resolution mode now offers an impressive 0.141 mm resolution.",
                                "source": "https://news.samsung.com/global/neurologica-corp-receives-fda-510k-clearance-for-enhanced-omnitom-elite-with-ultra-high-resolution-pcd-technology"
                            }
                        ]
                    },
                ],
                "score": 9
            },
            
        ],
        "patent_infringement_score": {patentNumber: 0}
    }
  })

}
etaValue=0;
progressPercentage=0;
async generateClaimChart(){
  /*
  Endpoint: /infringement-assesment/claim-charts
  Request: {"data": list of dictionaries ([{}, {}, {},………..])}
where each dictionary is {"patent_number": str, "targeted_product": str, "technical_documentation_links": list of links (list of strings), "prompt_template_source": str}

Note: The value of "prompt_template_source" should be "file"

  Response: 
    "claim_charts_data": {
        "claim_charts": [
            {
                "patent_number": "US8373135B2",
                "targeted_product": "Samsung Healthcare Computed Tomography Devices with Photon Counting Detector (PCD) Technology",
                "claim": "A counting detector, comprising: sensors to convert radiation quanta into electrical pulses; an evaluation unit, including a number of energy thresholds, to generate, for each of the sensors, a count value for each of the energy thresholds from the electrical pulses, each of the count values representing a number of radiation quanta with an energy above a respective one of the energy thresholds, wherein one of the energy thresholds is arranged directly above a characteristic energy of radiation quanta causing double counting in order to correct double counting; and a correction unit to calculate a corrected count value from the count values of the energy thresholds, the corrected count value including reduced double counting for at least one of the energy thresholds.",
                "data": [
                    {
                        "claim_element": "- A counting detector  ",
                        "analyst_comment": "The claim element 'A counting detector' is explicitly supported by multiple references to the Photon Counting Detector (PCD) technology utilized in the OmniTom Elite CT scanner. These references describe the functionality and capabilities of the PCD, emphasizing its role in capturing CT data and generating spectral images, which aligns directly with the concept of a counting detector.",
                        "references": [
                            {
                                "reference": "Counting DetectorPhoton Counting Detector (PCD)Samsung NeuroLogica\n\n\nProducts > More ProductsPress Resources > Press Release \n\n\nRelated Articles\n\n\nSamsung’s Push To Leverage Artificial Intelligence on Display at RSNA 2021",
                                "source": "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite"
                            },
                            {
                                "reference": "NeuroLogica Corp, a subsidiary of Samsung Electronics Co. Ltd., announced today its state-of-the-art OmniTom Elite has received 510(k) clearance for the addition of Photon Counting Detector (PCD) technology.",
                                "source": "https://www.neurologica.com/publications/press-releases/neurologicas-omnitom-elite-ct-scanner-now-available-0"
                            },
                            {
                                "reference": "NeuroLogica delivers the first FDA 510(k) cleared, single-source photon counting computed tomography (CT) scanner with single detector.\n\nOmniTom Elite with PCD can generate spectral CT imagesat multiple energy levels.\n\nPhoton counting is a next-generation CT technology that sorts the different energies of X-rays after they have passed through the scan field.\n\nA single X-ray source paired with PCD generates multiple sets of CT data acquired at the same time with configurable energy thresholds without any cross talk between images.\n\nPCD provides the ability to capture CT data in multiple energy bands leading to potentially more accurate visualization and segmentation of bone, blood clots, plaque, hemorrhage, and intracranial tumors.\n\nThere is also potential with PCD to lower the dose requirements, and fundamentally change the use of injected contrast.",
                                "source": "https://www.neurologica.com/publications/press-releases/neurologicas-omnitom-elite-ct-scanner-now-available-0"
                            },
                            {
                                "reference": "The clinical launch of the OmniTom Elite with PCD, the first US FDA 510(k) cleared single-source photon counting computed tomography scanner with a single detector on a mobile system, will be featured at this year’s meeting.\n\nPhoton counting is a next-generation CT technology that sorts the different energies of X-rays after they have passed through the scan field, capturing the X-ray photons directly at the detector and converting the energy to electrical signals.",
                                "source": "https://www.neurologica.com/publications/press-releases/samsung-ushers-in-a-new-era-of-diagnostic-solutions-at-rsna-2023"
                            },
                            {
                                "reference": "The world of medical imaging is no longer just black & white.\n\nNeuroLogica Corp, a subsidiary of Samsung Electronics, announced today its state-of-the-art OmniTom Elite has received 510(k) clearance for the addition of Photon Counting Detector (PCD) technology.\n\nNeuroLogica delivers the first FDA 510(k) cleared, single-source photon counting computed tomography (CT) scanner with single detector.\n\nOmniTom Elite with PCD can generate spectral CT images at multiple energy levels.\n\nPhoton counting is a next-generation CT technology that sorts the different energies of X-rays after they have passed through the scan field.\n\nA single X-ray source paired with PCD generates multiple sets of CT data acquired at the same time with configurable energy thresholds without any cross talk between images.\n\nPCD provides the ability to capture CT data in multiple energy bands leading to potentially more accurate visualization and segmentation of bone, blood clots, plaque, hemorrhage and intracranial tumors.\n\nThere is also potential with PCD to lower the dose requirements, and fundamentally change the use of injected contrast.",
                                "source": "https://news.samsung.com/global/neurologica-announces-fda-510k-clearance-for-photon-counting-computed-tomography-using-omnitom-elite"
                            },
                            {
                                "reference": "NeuroLogica Corp, a subsidiary of Samsung Electronics, announced its latest configuration of the mobile computed tomography (CT) OmniTom® Elite with Photon Counting Detector (PCD) technology has received U.S. Food and Drug Administration (FDA) 510(k) clearance.\n\nThis advancement builds upon the existing PCD capabilities with groundbreaking enhancements, further solidifying OmniTom® Elite’s position at the forefront of mobile CT imaging technology.\n\nThe newly cleared features optimized for PCD include several significant innovations:\n \n\nUltra-High-Resolution Mode: This development promises unprecedented clarity and detail in CT imaging.\n\nThe addition of an ultra-high-resolution mode now offers an impressive 0.141 mm resolution.",
                                "source": "https://news.samsung.com/global/neurologica-corp-receives-fda-510k-clearance-for-enhanced-omnitom-elite-with-ultra-high-resolution-pcd-technology"
                            }
                        ]
                    },
                ],
                "score": 9
            },
            
        ],
        "patent_infringement_score": {"US8373135B2": 9}
    }
}

*/
if (this.mock) {
  const requestBody: any[] = [];
  this.patentDetails.forEach(patentInfo => {
    patentInfo.companies.forEach((company: any) => {
      company.products.forEach((product: any) => {
        requestBody.push({
          patent_number: patentInfo.patentNumber,
          targeted_product: product.name,
          technical_documentation_links: product.technicalDocumentationLinks,
          prompt_template_source: 'file'
        });
      });
    });
  });
  this.loadingText = 'Generating claim charts, please wait';
  this.isLoading = true;
  this.http.post('/infringement-assessment/claim-charts', { data: requestBody }).then(response => {
    this.apiResponse = response;
    this.claimChartData = response.claim_charts_data.claim_charts;
    this.patentInfringementScoreData = response.claim_charts_data.patent_infringement_score;
    this.isLoading = false;
    this.currentStage = 4;
  }).catch(error => {
    console.error('Error generating claim charts:', error);
    this.isError = true;
  });
} else {
  const requestBody: any[] = [];
this.patentDetails.forEach(patentInfo => {
  patentInfo.companies.forEach((company: any) => {
    company.products.forEach((product: any) => {
      requestBody.push({
        patent_number: patentInfo.patentNumber,
        targeted_product: product.name,
        targeted_company: company.name,
        technical_documentation_links: product.technicalDocumentationLinks,
        prompt_template_source: 'file'
      });
    });
  });
});
this.claimChartData = [];

const batchSize = 5;
let currentIndex = 0;
const progressDivisor=Math.ceil(requestBody.length/batchSize);
this.progressPercentage=-1;
this.isLoading = true; 
this.loadingText = 'Generating claim charts, please wait';
let etaCandidate=await this.calculateETA();
this.etaValue=etaCandidate*requestBody.length/2;
console.log('eta value'+this.etaValue)
const processBatch = () => {
  const batch = requestBody.slice(currentIndex, currentIndex + batchSize);

  /* ─────────── finished? ─────────── */
  if (batch.length === 0) {
    this.processClaimChartScoreData(() => {
    this.updateData({patentDetails: this.patentDetails,patentInfringementScoreData:this.patentInfringementScoreData, claimChartData:this.claimChartData }, "infringement", false)
      if (this.optimizedFlow) {
        this.isLoading = false;
      } else {
        this.onFinalNext();
      }
      window.sessionStorage.setItem('notSurpass', 'true');
      this.currentStage = 4;
      this.progressPercentage=-1;
    });
    return;
  }

  /* ─────────── still working… ─────── */
  this.loadingText =
    `Generating claim charts, please wait ` +
    `(Processing ${currentIndex + 1}-${currentIndex + batch.length} of ${requestBody.length})`;

  /* fire off the requests */
  const batchPromises = batch.map(item =>
    this.http.post('/infringement-assessment/claim-charts', { data: [item] })
  );

  /* use allSettled so the loop never rejects */
  Promise.allSettled(batchPromises).then(results => {
    results.forEach((result, idx) => {
      const originalItem = batch[idx];                   // <-- to get patent number
      const response =
        result.status === 'fulfilled'
          ? result.value                                  // ✅ API response
          : this.sampleresponse(originalItem.patent_number); // ❌ fallback with correct patent #

      if (result.status === 'rejected') {
        // alert('Error generating claim chart for patent: ' + originalItem.patent_number);
        this.updateData({patentDetails: this.patentDetails,patentInfringementScoreData:this.patentInfringementScoreData, claimChartData:this.claimChartData }, "infringement", false)
        console.error('Error generating claim chart:', result.reason);
      this.dataService.handleWorkflowError();
        this.isError = true;
      }

      console.log('api response', response);  

      /* identical post-processing */
      this.apiResponse = this.deepCombineObjects(this.apiResponse, response);

      const updatedClaimCharts = this.processClaimChartData(
        response.claim_charts_data.claim_charts
      );
      console.log('updatedClaimCharts', updatedClaimCharts);
      if(updatedClaimCharts.length === 0) {
        updatedClaimCharts.push({
          patent_number: originalItem.patent_number,
          targeted_product: originalItem.targeted_product,
          score:0,
          isError: true,
          errorMessage: 'No claim charts generated for this patent.'
        });
      }
      
      
      this.claimChartData = [...this.claimChartData, ...updatedClaimCharts];
      this.tempScoreData.push(
        response.claim_charts_data.patent_infringement_score
      );
    });

    /* next slice */
    currentIndex += batchSize;
    this.progressPercentage = Math.floor(
      ((currentIndex / requestBody.length) * 100) / progressDivisor
    );
    processBatch();
  });
};

this.progressPercentage = 0;

processBatch();



}
}

processClaimChartScoreData(callback:any){
console.log(this.tempScoreData)

/*
  [
    {
        "US8558755B2": 2
    },
    {
        "US8558755B2": 0
    },
    {
        "US8558755B2": 0
    },
    {
        "US8558755B2": 0
    },
    {
        "US8558755B2": 0
    }
]
    this is what the tempScoreData looks like

    request body: 
    {
"data":
[
    {"patent_number": "US123", "score": 10},
    {"patent_number": "US456", "score": 20},
    {"patent_number": "US123", "score": 5},
    {"patent_number": "US789", "score": 15},
    {"patent_number": "US456", "score": 5},
    {"patent_number": "US999", "score": 12},
    {"patent_number": "US789", "score": 3}
]
}

response: 

{
    "score": [
        {
            "patent_number": "US123",
            "score": 15
        },
        {
            "patent_number": "US456",
            "score": 25
        },
        {
            "patent_number": "US789",
            "score": 18
        },
        {
            "patent_number": "US999",
            "score": 12
        }
    ],
    "status_code": 200
}

url: /infringement-assessment/calculate-patent-score
*/

let requestBody:any=[]
this.tempScoreData.forEach((item:any)=>{
  for (const key in item) {
    requestBody.push({
      patent_number: key,
      score: item[key]
    });
  }
});

return this.http.post('/infringement-assessment/calculate-patent-score', {data: requestBody}).then(response => {
  // patentinfringementscoredata is again patentnumber as key and score as value
  this.patentInfringementScoreData=response.score.reduce((acc:any, item:any)=>{
    acc[item.patent_number]=item.score;
    return acc;
  }, {});
  callback();
  console.log('Patent infringement score:', this.patentInfringementScoreData);
}).catch(error => {
  console.error('Error calculating patent score:', error);
  this.isError=true;
});

}
async calculateETA(){
    let api1 = '/infringement-assessment/claim-charts';

    let apiList = [api1];

    let serverUrl = AppConstants.SERVER_CONFIG.URL;

    apiList = apiList.map((api: any) => serverUrl + api);

    let etaArray: any[] = [];

    const calculateEtaForApi = async (api: string) => {
      const apiDetails = {
      api_name: api,
      request_size: 0,
      response_size: 0,
      eta: 0,
      };

      let existingDetails = {
      api_name: api,
      request_size: 0,
      response_size: 0,
      eta: 0,
      number_of_saves: 0,
      };

      const response = await this.callCalculateTimeApi(apiDetails);
      let eta = response?.eta ?? 0;
      existingDetails = { ...existingDetails, ...response };
      etaArray.push(eta);
    };

    await Promise.all(apiList.map(api => calculateEtaForApi(api)));

    let sum = etaArray.reduce((acc, eta) => acc + eta, 0);
    return sum;
    


  }
openEditLinksDialog(targetedProduct: string, patentNumber: string) {
  let foundProduct:any=undefined;
  this.patentDetails.forEach(patentInfo => {
    patentInfo.companies.forEach((company:any) => {
      company.products.forEach((product:any) => {
        if(targetedProduct==product.name&&patentNumber==patentInfo.patentNumber){
          foundProduct=product;
        }
      });
    });
  });
  let links=foundProduct.technicalDocumentationLinks;
  const dialogRef = this.dialog.open(EditLinksDialogComponent, {
    width: '500px',
    data: { targetedProduct,  links }
  });

  dialogRef.afterClosed().subscribe(updatedLinks => {
    if (updatedLinks) {
      console.log('Updated links:', updatedLinks);
      foundProduct.technicalDocumentationLinks=updatedLinks;
      this.regenerateClaimChart(patentNumber, targetedProduct);
    }
  });
}

regenerateClaimChart(patentNumber:any, targetedProduct:any){
  let foundProduct:any=undefined;
  this.patentDetails.forEach(patentInfo => {
    patentInfo.companies.forEach((company:any) => {
      company.products.forEach((product:any) => {
        if(targetedProduct==product.name&&patentNumber==patentInfo.patentNumber){
          foundProduct=product;
        }
      });
    });
  });
  
  const requestBody={
    patent_number: patentNumber,
    targeted_product: foundProduct.name,
    technical_documentation_links: foundProduct.technicalDocumentationLinks,
    prompt_template_source: 'file'
  };
  this.loadingText = 'Regenerating claim chart, please wait';
  this.isLoading = true;

  this.http.post('/infringement-assessment/claim-charts', {data: [requestBody]}).then(response => {
    
    const updatedClaimCharts = this.processClaimChartData(
      response.claim_charts_data.claim_charts
    );
    console.log('updatedClaimCharts', updatedClaimCharts);
    if(updatedClaimCharts.length === 0) {
      updatedClaimCharts.push({
        patent_number: patentNumber,
        targeted_product: foundProduct.name,
        score:0,
        isError: true,
        errorMessage: 'No claim charts generated for this patent.'
      });
    }
    this.claimChartData=this.claimChartData.map((claimChart:any)=>{
      if(claimChart.patent_number==patentNumber && claimChart.targeted_product==foundProduct.name){
        return updatedClaimCharts[0];
      }
      return claimChart;
    });
    this
    // this.patentInfringementScoreData=response.claim_charts_data.patent_infringement_score;
    this.tempScoreData.push(response.claim_charts_data.patent_infringement_score);
    this.processClaimChartScoreData(()=>{

      this.isLoading = false;
      this.updateData({patentDetails: this.patentDetails, patentInfringementScoreData:this.patentInfringementScoreData, claimChartData:this.claimChartData }, "infringement", false)
    })

  }).catch(error => {
    // this.isLoading = false;
    this.isError=true;
    console.error('Error regenerating claim chart:', error);
  });
}

  handleInputLinkUpdate(company:any, product:any)
  {
    const dialogRef = this.dialog.open(LinkInputPopupComponent, {
      width: '300px',
      data: { inputValue: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('Value received from popup:', result);
        if(!product.technicalDocumentationLinks){
          product.technicalDocumentationLinks=[];
        }
        product.technicalDocumentationLinks.push(result);
        this.updateData({patentDetails: this.patentDetails}, "infringement", false)
      }
    });
  }

  handleFileLinkUpdate(company:any, patent:any){
    const dialogRef = this.dialog.open(FileUploadPopupComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('File received from popup:', result);
        this.uploadFileLinkUpdate(result, company, patent);
      }
    });
  
  }

  openLinksDialog(product:any)
  {
    const dialogRef = this.dialog.open(LinksDialogComponent, {
      width: '600px',
      data: { links: product.technicalDocumentationLinks }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('Value received from popup:', result);
        product.technicalDocumentationLinks=result;
        // find out the product and company and update the links
        
      }
    });
  }

  minStep=2;

  goBack(){
    if(this.currentStage>this.minStep)
      this.currentStage--;
    else{
      window.history.back();
    }
  }
  
  onClickCancel(){
    this.dataService.onClickCancel.bind(this.dataService)();
  }

  uploadFileLinkUpdate(file:any, company:any, product:any){
    console.log(file)
    let formData=new FormData();
    formData.append('file', file);
    this.loadingText = 'Uploading file, please wait';
    this.isLoading = true;
    this.http.postFormData('//infringement-assessment/upload-user-technical-documentation', formData).then(response => {
      console.log(response)
      if(!product.technicalDocumentationLinks){
        product.technicalDocumentationLinks=[];
      }
      product.technicalDocumentationLinks.push(response.user_technical_documentation_link);
      this.updateData({patentDetails: this.patentDetails}, "infringement", false);
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      console.error('Error uploading file:', error);
    });
  }

  startTargetScouting(): void {
    this.isLoading = true;
    this.loadingText = 'Retrieving Target Companies, please wait';
    if(this.mock){
      setTimeout(() => {
        this.getTargetCompanies();
      }, 0);
    }
    else{

      this.getTargetCompanies();
    }
  }

  getTargetCompanies(): void {
    if (this.mock) {
      // Mock response for target companies
      this.patentDetails = this.patentData.map((patent:any) => ({
        ...patent,
        companies: [
          {
            name: 'Alpha Corp.',
            products: []
          },
          {
            name: 'Beta Inc.',
            products: []
          }
        ]
      }));
      this.getCompanyInformation();
    } else {
      console.log(this.patentData)
      const requests = this.patentData.map((patent:any) =>
        this.http.post('/targetCompanies', { patentNumber: patent.patentNumber })
      );

      Promise.all(requests).then(responses => {
        this.patentDetails = responses.map((res: any, index: number) => ({
          // patentNumber: this.patentData[index].patentNumber,
          companies: res.targetCompanies.map((company: string) => ({ name: company, products: [] })),
          ...this.patentData[index]
        }));
      }).catch(error => {
        console.error('Error fetching target companies:', error);
      });
      this.getCompanyInformation();
    }
  }

  getCompanyInformation(){
    this.isLoading = true;
    this.loadingText = 'Retrieving Company Information, please wait';
     setTimeout(() => {
      this.getCompanyInfo();
    }, 2000);
  }

  getCompanyInfo(): void {
  if(this.mock)
  {
    /*"CompanyInformation": {

    "Global Headquarters": {

      "response": "",

      "sourceLink": ""

    },

    "US Headquarters": {

      "response": "",

      "sourceLink": ““

    },

    "State of Incorporation": {

      "response": "",

      "sourceLink": ""

    },

    "Revenue": {

      "response": "",

      "sourceLink": ""

    }

  }*/
//  this is the mock response for company information
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        console.log(patentInfo)
        company.companyInfo = {
          "Global Headquarters": {

            "response": "New York, NY",

            "sourceLink": "N/A"

          },

          "US Headquarters": {

            "response": " New York, NY",

            "sourceLink": "N/A"

          },

          "State of Incorporation": {

            "response": " Delaware",

            "sourceLink": "N/A"

          },

          "Revenue": {

            "response": "Revenue: $50-60 million USD",

            "sourceLink": "N/A"

          }
        };
      });
    });
    this.isLoading = false;
    this.currentStage = 2;
  }
  else {
    const requests = this.patentDetails.flatMap(patentInfo =>
      patentInfo.companies.map((company: any) =>
        this.http.post('/extractCompanyInformation', {
          patentNumber: patentInfo.patentNumber,
          companyName: company.name,
          modelName: 'perplexity-llama-3.1-sonar'
        })
      )
    );

    Promise.all(requests).then(responses => {
      console.log('response to api')
      let index = 0;
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company: any) => {
          console.log(responses[index].CompanyInformation)
          company.companyInfo = responses[index++].CompanyInformation;
        });
      });
    }).finally(()=>{
      this.isLoading = false;
      console.log('post api')
      this.currentStage = 2;
    })
    .catch(error => {
      console.error('Error fetching company information:', error);
      // this.isLoading = false;
    });
  }

  }

  getNewCompanyInfo(){
    console.log(this.patentDetails)
    let companyList:any=[]
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        if(company.new){
          companyList.push({patentNumber:patentInfo.patentNumber, companyName:company.name});
        }
      });
    });
    console.log(companyList)
  //  this would consist a list of patent number and company name. use the same logic but update on the same patent number and company name. this function would be making the api call. company list structure {patentNumber, companyName}
  this.isLoading = true;  
  this.loadingText = 'Retrieving Company Information, please wait';
  if(this.mock){
    // based on response, update the new companies. all new companies have new in their object.
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        if(company.new){
          company.companyInfo = {
            "Global Headquarters": {

              "response": "New York, NY",

              "sourceLink": "N/A"

            },

            "US Headquarters": {

              "response": " New York, NY",

              "sourceLink": "N/A"

            },

            "State of Incorporation": {

              "response": " Delaware",

              "sourceLink": "N/A"

            },

            "Revenue": {

              "response": "Revenue: $50-60 million USD",

              "sourceLink": "N/A"

            }
          };
          company.new=false
        }
      });
    });
    this.isLoading = false;
  }
  else 
  {
    const requests = companyList.map((company:any) =>
      this.http.post('/extractCompanyInformation', {
        patentNumber: company.patentNumber,
        companyName: company.companyName,
        modelName: 'perplexity-llama-3.1-sonar'
      })
    );

    // only update the company info for the company that was updated, match on the basis of patent number as well 
    Promise.all(requests).then(responses => {
      let index = 0;
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company: any) => {
          console.log(company, company.new)
          if(company.new){
            company.companyInfo = responses[index++].CompanyInformation;
          }
          company.new=false
        });

      });
      this.isLoading = false;
    }).catch(error => {
      console.error('Error fetching company information:', error);
      this.isLoading = false;
    });

  }

  }



  proceedToTargetProducts(): void {
    this.isLoading = true;
    this.loadingText = 'Retrieving Target Products, please wait';
    setTimeout(() => {
      this.getTargetProducts();
    }, 2000);
  }

  getTargetProducts(): void {
    if (this.mock) {
      // Mock response for target products
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          company.products = [
            { name: 'Product A' },
            { name: 'Product B' }
          ];
        });
      });
      this.isLoading = false;
      this.currentStage = 3;
    } else {
      const requests = this.patentDetails.flatMap(patentInfo =>
        patentInfo.companies.map((company: any) =>
          this.http.post('/productInformation', {
            patentNumber: patentInfo.patentNumber,
            companyName: company?.name,
            modelName: 'perplexity-llama-3.1-sonar'
          })
        )
      );

      Promise.all(requests).then(responses => {
        let index = 0;
        this.patentDetails.forEach(patentInfo => {
          patentInfo.companies.forEach((company: any) => {
            company.products = responses[index++].ProductInformation['Targeted products'].map((product: any) => ({ name: product.response }));
          });
        });
      }).finally(()=>{
        this.isLoading = false;
        this.currentStage = 3;
      }).catch(error => {
        console.error('Error fetching target products:', error);
        this.isLoading = false;
      });
    }
  }

  proceedToRevenueIdentification(): void {
    this.isLoading = true;
    this.loadingText = 'Retrieving Revenue Details, please wait';
    setTimeout(() => {
      this.getRevenueDetails();
      this.titleText = 'Revenue Identification';
    }, 2000);
  }

  getRevenueDetails(): void {
    if (this.mock) {
      // Mock response for revenue details
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          company.revenue = [
            {
              response: ' $50-60 million USD',
              sourceLink: 'N/A'
            }
          ];
          company.products.forEach((product: any) => {
            product.revenue = ' $5-10 million USD';
          });
        });
      });
      this.isLoading = false;
      this.currentStage = 4;
    } else {
      const requests = this.patentDetails.flatMap(patentInfo =>
        patentInfo.companies.map((company: any) =>
          this.http.post('/revenueInformation', {
            patentNumber: patentInfo.patentNumber,
            companyName: company.name,
            productList: company.products.map((product: any) => product.name),
            modelName: 'perplexity-llama-3.1-sonar'
          })
        )
      );

      Promise.all(requests).then(responses => {
        let index = 0;
        this.patentDetails.forEach(patentInfo => {
          patentInfo.companies.forEach((company: any) => {
            company.products.forEach((product: any) => {
              /*{

  "RevenueInformation":[ {

        "Verizon Media Smartplay Prebid": {

          "response": "Information not available",

          "sourceLink": "Information not available"

            }},{

        "Verizon Media DSP": {

          "response": "Information not available",

          "sourceLink": "Information not available"}

            }},{

        "Next-Gen Solutions": {

          "response": "Information not available",

          "sourceLink": "Information not available"

            }}

      }

]
}
  }*/
              // map the product revenue by matching the product name
              console.log(responses[index], product)
             responses[index].RevenueInformation["Product Revenue"].forEach((revenue:any) => {
              if(Object.keys(revenue)[0] === product.name){
                product.revenue = revenue[product.name]
                console.log(product)
              }
            });
          });
            index++;
        });
      })
    }).finally(()=>{
      this.isLoading = false;
      this.currentStage = 4;
    }).catch(error => {
        console.error('Error fetching revenue details:', error);
        this.isLoading = false;
      });
    }
  }

  toggleEditCompanies(): void {
    this.isEditingCompanies = !this.isEditingCompanies;
    if(this.isEditingCompanies){
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          company.new = false;
        });
      });
    }
    else {
      this.getNewCompanyInfo();
    }
  }

  handleCompanyChange(event:any, company:any)
  {
    console.log(event, company)
    company.new=true;
  }

  addCompany(patent: any): void {
    patent.companies.push({ name: '', products: [], new:true });
  }

  confirmEditCompany(): void {
    this.isEditingCompanies = false;
    this.getNewCompanyInfo();
  }

  toggleEditProducts(): void {
    this.isEditingProducts = !this.isEditingProducts;
  }

  addProduct(company: any): void {
    company.products.push({ name: '' });
  }

  confirmEditProduct(): void {
    this.isEditingProducts = false;
  }
  deleteCompany(patent: any, companyIndex: number): void {
    patent.companies.splice(companyIndex, 1);
  }
  deleteProduct(company: any, productIndex: number): void {
    company.products.splice(productIndex, 1);
  }
  saveCompanies(): void {
    this.isEditingCompanies = false;
  }
  saveProducts(): void {
    this.isEditingProducts = false;
  }

  handlePopupSubmit(value: string): void {
    console.log('Value received from popup:', value);
  }
  openPopup(patentNumber:any, productName:any, companyName:any): void {
    const dialogRef = this.dialog.open(LinkInputPopupComponent, {
      width: '300px',
      data: { inputValue: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('Value received from popup:', result);
        this.handleInputPopup(result, patentNumber, productName, companyName);
      }
    });
  }

  assistMode=false;

  toggleAssistMode(){
    this.assistMode=!this.assistMode
  }

  handleInputPopup(value: string, patentNumber:any, productName:any, companyName:any): void {
    /*{

  "url": "https://en.wikipedia.org/wiki/Verizon",

  "patentNumber": "US6421675B1",

  "productName": "",

  "companyName": "Verizon Media Inc."

}

Response:

{

  "revenueInformationURLModel": {

    "response": "245.1 - 245.1 billion",

    "sourceLink": "https://www.microsoft.com/en-us/investor/earnings/fy-2024-q4/press-release-webcast"

  }*/
 // make this api call and update the revenue information for the product. if product is "", then you need to update the revenue information of the company
  this.isLoading = true;
  this.loadingText = 'Retrieving Revenue Details, please wait';
  this.http.post('/revenueURLInformation', {
    url: value,
    patentNumber: patentNumber,
    productName: productName,
    companyName: companyName
  }).then(response => {
    console.log(response, response.revenueInformationURLModel)
    if(productName === ""){
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          if(company.name === companyName){
            company.revenue = [
              {
                response: response.revenueInformationURLModel.response,
                sourceLink: response.revenueInformationURLModel.sourceLink
              }
            ];
          }
        });
      });
    }
    else{
      this.patentDetails.forEach(patentInfo => {
        patentInfo.companies.forEach((company:any) => {
          if(company.name === companyName){
            company.products.forEach((product:any) => {
              if(product.name === productName){
                product.revenue = response.revenueInformationURLModel;
                console.log('updating product revenue:', product.revenue, response.revenueInformationURLModel.response);
                console.log(product)
              }
            });
          }
        });
      });
    }
    this.isLoading = false;
  }).catch(error => {
    console.error('Error fetching revenue details:', error);
    this.isLoading = false;
  });
  }


  openFileUploadPopup(patentNumber:any, productName:any, companyName:any): void {
    const dialogRef = this.dialog.open(FileUploadPopupComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        console.log('File received from popup:', result);
        this.handleProductRevenueFileUpload(result, patentNumber, productName, companyName);
      }
    });
  
}

  handleProductRevenueFileUpload(file:any, patentNumber:any, productName:any, companyName:any ){
    /*
    Endpoint: /revenuePDFInformation

Resquest: 

Body:

File

Parameters:

patentNumber

productName

companyName

Response:

{

  "revenueInformationPDFModel": {

    "response": "168,088 - 211,915 million",

    "sourceLink": "https://storage.googleapis.com/infringement_detector/revenue%20information/0000950170-23-035122.pdf"

  }

}*/
// make this api call and update the revenue information for the product. if product is "", then you need to update the revenue information of the company
this.isLoading = true;
this.loadingText = 'Retrieving Revenue Details, please wait';
// 
const formData=new FormData();
formData.append('file', file);
this.http.postFormData('/revenuePDFInformation?patentNumber',  formData, {
  params: {patentNumber: patentNumber, productName: productName, companyName: companyName}
}).then(response => {
  if(productName === ""){
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        console.log(company, companyName)
        if(company.name === companyName){
          company.companyInfo.Revenue = {
              response: response.revenueInformationPDFModel.response,
              sourceLink: response.revenueInformationPDFModel.sourceLink
            }
        }
      });
    });
  }
  else{
    this.patentDetails.forEach(patentInfo => {
      patentInfo.companies.forEach((company:any) => {
        if(company.name === companyName){
          company.products.forEach((product:any) => {
            console.log(product, productName)
            if(product.name === productName){
              product.revenue = response.revenueInformationPDFModel;
            }
          });
        }
      });
    });
  }
    this.isLoading = false;
})
  .catch(error => {
    console.error('Error fetching revenue details:', error);
    this.isLoading = false;
  });
  }

  showRevenueControls(company:any){
    if(company.showRevenue){

      company.showRevenue=false;
    }
    else{
      company.showRevenue=true;
    }
  }

  showProductRevenueControls(product:any){
    if(product.showRevenue){

      product.showRevenue=false;
    }
    else{
      product.showRevenue=true;
    }
  }
  processClaimChartData(claimChartData: any[]): any[] {
    const removeDuplicateSources = (claimElement: any) => {
        const uniqueSources = new Set<string>();
        claimElement.references = claimElement.references.map((reference: any) => {
            if (uniqueSources.has(reference.source)) {
                // If the source is a duplicate, clear it
                return { ...reference, source: '' };
            } else {
                // Otherwise, add it to the set and keep it
                uniqueSources.add(reference.source);
                return reference;
            }
        });
    };
  
    // Process the entire claim chart data
    claimChartData.forEach((claimData: any) => {
        claimData.data.forEach((claimElement: any) => {
            removeDuplicateSources(claimElement);
        });
    });
  
    return claimChartData;
  }

  referenceDivOpenMapObj:any={};
  referenceTableOpenMapObj:any={};

  referenceDivOpenMap(patentNumber:any, index:any){
    if(!this.referenceDivOpenMapObj[patentNumber]){
      if(index==0&&this.referenceDivOpenMapObj[patentNumber]===undefined){
        this.referenceDivOpenMapObj[patentNumber]=true;
      }
      else
      this.referenceDivOpenMapObj[patentNumber]=false;
    }
    else{
      this.referenceDivOpenMapObj[patentNumber]=true;
    }
    return this.referenceDivOpenMapObj[patentNumber];
  }

  referenceTableOpenMap(patentNumber:any, referenceNumber:any, index:any){
    // map based on patentNumber and further referenceNumber. If the reference Object does not exist, create a new object with the referenceNumber as key and value as false
    if(!this.referenceTableOpenMapObj[patentNumber]){
      if(index==0&&this.referenceTableOpenMapObj[patentNumber]===undefined){
        this.referenceTableOpenMapObj[patentNumber]={};
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=true;
      }
      else
      this.referenceTableOpenMapObj[patentNumber]={};
    }
    else{
      if(!this.referenceTableOpenMapObj[patentNumber][referenceNumber]){
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=true;
      }
      else{
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=false;
      }
    }
    return this.referenceTableOpenMapObj[patentNumber][referenceNumber];
  }

  toggleReferenceTable(patentNumber:any, referenceNumber:any){
    if(!this.referenceTableOpenMapObj[patentNumber]){
      this.referenceTableOpenMapObj[patentNumber]={};
      this.referenceTableOpenMapObj[patentNumber][referenceNumber]=false;
    }
    else{
      if(!this.referenceTableOpenMapObj[patentNumber][referenceNumber]){
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=true;
      }
      else{
        this.referenceTableOpenMapObj[patentNumber][referenceNumber]=false;
      }
    }
  }
  
  toggleReferenceDiv(patentNumber:any){
    this.referenceDivOpenMapObj[patentNumber]=!this.referenceDivOpenMapObj[patentNumber];
    console.log('referenceDivOpenMapObj:', this.referenceDivOpenMapObj)
  }

  get allExpanded(){
    let claimData=this.claimChartData;
    let allExpanded=true;
    claimData.forEach((item:any, i:any)=>{
      if(!this.referenceDivOpenMapObj[item.patent_number+''+i]){
        allExpanded=false;
      }
    });
    return allExpanded;
  }

  expandAllReferences() {
    let claimData=this.claimChartData;
    
    // loop through and update referencedivopenmapobj
    console.log(claimData)
    
    if(!this.allExpanded){
    this.referenceDivOpenMapObj={};
    claimData.forEach((item:any, i:any)=>{
      if(!this.referenceDivOpenMapObj[item.patent_number+''+i]){
        this.referenceDivOpenMapObj[item.patent_number+''+i]=true;
      }
    });
    console.log('all expanded:', this.referenceDivOpenMapObj)
  }
  else{
    this.referenceDivOpenMapObj={};
    claimData.forEach((item:any, i:any)=>{
      if(!this.referenceDivOpenMapObj[item.patent_number+''+i]){
        this.referenceDivOpenMapObj[item.patent_number+''+i]=false;
      }
    });
    
  }
  }
  
  
exportClaimChartToDocx(claimData: any) {

    const tableRows: TableRow[] = [];
  
    // Table header
    tableRows.push(new TableRow({
      children: [
        new TableCell({
          width: { size: 33.3, type: WidthType.PERCENTAGE },
          children: [new Paragraph({ children: [new TextRun({ text: "Claims", bold: true })] })],
        }),
        new TableCell({
          width: { size: 33.3, type: WidthType.PERCENTAGE },
          children: [new Paragraph({ children: [new TextRun({ text: "Infringement", bold: true })] })],
        }),
        new TableCell({
          width: { size: 33.3, type: WidthType.PERCENTAGE },
          children: [new Paragraph({ children: [new TextRun({ text: "Score", bold: true })] })],
        }),
      ],
    }));
  
    // Data rows
    claimData.data.forEach((claimElement: any, index: number) => {
      // Build the Infringement Column content
      const infringementParagraphs: Paragraph[] = [];
  
      // Analyst Comment
      if (claimElement.analyst_comment) {
        infringementParagraphs.push(
          new Paragraph({
            children: [
              new TextRun({ text: "Analyst Comment: ", bold: true }),
              new TextRun(claimElement.analyst_comment),
            ],
          })
        );
      }
  
      // References
      if (claimElement.references && claimElement.references.length > 0) {
        // Header for grouped references & sources
        infringementParagraphs.push(
          new Paragraph({
            children: [
              new TextRun({ text: "References & Sources:", bold: true })
            ]
          })
        );

        // Show each reference with its corresponding source immediately after
        claimElement.references.forEach((ref: any) => {
          if (ref.reference) {
            infringementParagraphs.push(
              new Paragraph({
                children: [
                  new TextRun({
                    text: `• ${ref.reference}`,
                    italics: true
                  })
                ]
              })
            );
          }
          if (ref.source) {
            infringementParagraphs.push(
              new Paragraph({
                children: [
                  new ExternalHyperlink({
                    link: ref.source,
                    children: [
                      new TextRun({
                        text: ref.source,
                        style: "Hyperlink"
                      })
                    ]
                  })
                ]
              })
            );
          }
        });
      }
  
      tableRows.push(new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph(claimElement.claim_element)],
          }),
          new TableCell({
            children: infringementParagraphs,
          }),
          new TableCell({
            children: index === 0
              ? [new Paragraph(` ${claimData.score}`)]
              : [],
          }),
        ],
      }));
    });
  
    const doc = new Document({
      sections: [{
        children: [
          new Paragraph({
            text: `${claimData.patent_number} vs. ${claimData.targeted_product}`,
            heading: HeadingLevel.HEADING_1,
          }),
          new Table({
            rows: tableRows,
            width: { size: 100, type: WidthType.PERCENTAGE },
          }),
        ],
      }],
    });
  
    Packer.toBlob(doc).then(blob => {
      saveAs(blob, `${claimData.patent_number}_vs_${claimData.targeted_product}.docx`);
    });
  }
  

exportPDF(id: string) {
  // this.exportingState=true;
  // this.exportUI=true;
  setTimeout(() => {
  var element:any = document.getElementById(id);
  
  // if(this.selectedPatentIndex!=null){
  //   element=document.getElementById('major-report');
  //   console.log(element)
  // }
  element.classList.add('min-height');
  let opt={
    filename:'sniff-report.pdf',
    width: 2500,
    height:100,

  }
    
  //      //$("#previewBeforeDownload").html(canvas);
  //      var imgData = canvas.toDataURL("image/jpeg",1);
  //      var pdf = new jsPDF("p", "px", "a2");
  //      // var pageWidth = pdf.internal.pageSize.getWidth();
  //      var pageWidth=pdf.internal.pageSize.getWidth();
  //      var pageHeight = pdf.internal.pageSize.getHeight();
  //      var imageWidth = canvas.width;
  //      var imageHeight = canvas.height;
 
  //      var ratio = imageWidth/imageHeight >= pageWidth/pageHeight ? pageWidth/imageWidth : pageHeight/imageHeight;
  //      //pdf = new jsPDF(this.state.orientation, undefined, format);
  //      pdf.addImage(imgData, 'JPEG', 0, 0, imageWidth * ratio, imageHeight * ratio);
  //      pdf.save("sniff-report.pdf");
  //  });
 // Get the dimensions of the HTML element
const elementHeight = element.offsetHeight;
const elementWidth = element.offsetWidth;

// Estimate the timeout based on the element's height (e.g., 1ms per pixel)
const estimatedTimeout = elementHeight * 1; // Adjust the multiplier as necessary

// html2canvas(element).then(canvas => {
//   var imgData = canvas.toDataURL("image/jpeg", 1);

//   // Get the dimensions of the canvas
//   var imageWidth = canvas.width;
//   var imageHeight = canvas.height;

//   // Calculate the required PDF dimensions
//   var pdfWidth = imageWidth;
//   var pdfHeight = imageHeight;
//   console.log('page dimensions:', pdfWidth, pdfHeight)
//   console.log('canvas details', imageWidth, imageHeight)
//   console.log('canvas details', canvas.width, canvas.height)

//   // Create the PDF with the calculated dimensions
//   var pdf = new jsPDF("p", "px", [pdfWidth, pdfHeight]);

//   // Add the image to the PDF
//   pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);

//   // Save the PDF
//   pdf.save("sniff-report.pdf");
// }).finally(() => {
//   // setTimeout(() => {
//     this.exportingState = false;
//     this.exportUI = false;
//     element.classList.remove('min-height');
//   // }, estimatedTimeout); // Use the estimated timeout
// });
html2canvas(element, { scale: 2 }).then(canvas => {
// Convert the canvas to image data
let scalingFactor=0.25;
if(canvas.width>3000)
{
  scalingFactor=1;
}
console.log('scaling factor', scalingFactor)
var imgData = canvas.toDataURL("image/jpeg", scalingFactor);

// Create a new jsPDF instance using A4 page size and "pt" as unit.
// (You can change "a4" to a custom format if desired.)
var pdf = new jsPDF("p", "pt", "a4");

// Get the PDF page dimensions (width and height in points)
var pageWidth = pdf.internal.pageSize.getWidth();
var pageHeight = pdf.internal.pageSize.getHeight();

// Calculate the image width and height for the PDF such that the image's width fits the page width.
// This ensures the aspect ratio is maintained.
var imgWidth = pageWidth;
var imgHeight = canvas.height * pageWidth / canvas.width;

// Initialize the position for the first image slice.
var position = 0;
var heightLeft = imgHeight;

// Add the first slice of the image to the PDF.
pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, 'FAST');
heightLeft -= pageHeight;

// As long as there is remaining image height, create additional pages.
while (heightLeft > 0) {
  // Move the position upward (a negative offset shifts the image for the new page).
  position = position - pageHeight;
  // Add a new page to the PDF.
  pdf.addPage();
  // Insert the image again with the new offset so that the next slice appears.
  pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, 'FAST');
  heightLeft -= pageHeight;
}

// Save the PDF
pdf.save("sniff-report.pdf");
}).finally(() => {
// Reset states and clean up UI
// this.exportingState = false;
// this.exportUI = false;
element.classList.remove('min-height');
});


  }, 10);
  }
  openEditDialog(claimData: any): void {
    const dialogRef = this.dialog.open(EditClaimchartPopupComponent, {
      data: { claimData: claimData },
      backdropClass: 'blur-background',
      panelClass: 'custom-dialog-panel',
      width: '90vw !important',
    });
  
    dialogRef.afterClosed().subscribe(updatedData => {
      console.log('updated data:', updatedData);
      if (updatedData) {
        // Update the claim chart data with the edited values
        this.claimChartData = this.claimChartData.map((item: any) => {
          if (item.patent_number === claimData.patent_number && item.targeted_product === claimData.targeted_product) {
            return {
              ...claimData,
              data:updatedData
            }
          }
          return item;
        });
        // Optionally, you can also update the patentDetails or any other related data here
      this.updateData({patentDetails: this.patentDetails,patentInfringementScoreData:this.patentInfringementScoreData, claimChartData:this.claimChartData }, "infringement", false)
      }
    });
  }

  showShareMenu:any={}

 toggleShareMenu(patentNumber:string){
  console.log('toggle share menu for patent number:', patentNumber, this.showShareMenu[patentNumber])
    if(!this.showShareMenu[patentNumber]){
      this.showShareMenu[patentNumber]=true;
    }
    else{
      this.showShareMenu[patentNumber]=false;
    }
  
 }

 clickOutsideShareMenu(e:any){
  console.log('clicked outside share menu', e);
  // This function is called when the user clicks outside the share menu
  // It will close all open share menus
  this.showShareMenu = {};
  console.log('clicked outside share menu, closing all menus');
 }
  

 getLinkOrText(link: string): string {
  if(link.startsWith('http')){
    return `<a href="${link}" target="_blank" rel="noopener noreferrer">${link}</a>`;
  }
  else{
    return link;
  }
 }

 roundFirstTenth(value:number): number {
  if(value==null||value==undefined){
   value;
  }
   return Math.round(value* 10) / 10
  }

}
